<template>
  <modal titulo="Imprimir" id="modal-imprimir" :loading="loading">
    <AlertBanner v-if="alerta && tipo !== 'LIVRO_ESTRANGEIRO'" message="Existem atos que não estão prontos para serem impressos: necessário verificar se os atos não impressos estão selados ou se possuem variáveis de texto não convertidas." type="alert-warning" />
    <card>
      <card-content v-if="!loading">

        <div class="row">

          <v-input type="select" :options="layouts" label="Layout" v-model="form.layout" :class="'col'" />
          <v-input type="select" :options="dpiDigitalizacao" label="Qualidade das imagens"
                   v-model="form.dpiDigitalizacao" class="col-auto" >
            <template #label>
              <a href class="icon" @click.prevent="exibirAjuda(textosAjuda.dpiDigitalizacao)" tabindex="-1">
                <i class="fal fa-question-circle pointer ml-2 small" title="Texto de Ajuda"></i>
              </a>
            </template>
          </v-input>
          <div class="w-100"></div>

          <template v-if="['REGISTRO_TD', 'REGISTRO_PJ'].includes(tipo) && !isLayoutV3">
            <template v-if="!simulacao">
              <v-input v-model="form.impressaoCompleta" label="Impressão completa?" type="radio" class="col-6" />
              <v-input v-model="form.considerarAtosDigitais" label="Considerar atos digitais?" type="radio" class="col-6" />
            </template>
          </template>

          <template v-if="!['LIVRO_ESTRANGEIRO', 'REGISTRO_TD', 'REGISTRO_PJ', 'REGISTRO_NOTAS'].includes(tipo) || isLayoutV3">
            <v-input label="Livro" v-model="form.livro" type="text" class="col-4" />


            <v-input v-model="form.impressaoCompleta" label="Impressão completa?" type="radio" class="col-4" />
            <v-input v-model="form.considerarAtosDigitais" label="Considerar atos digitais?" type="radio" class="col-4" />

            <template v-if="!form.impressaoCompleta">

              <v-input v-if="atosParaImpressao.length" v-model="form.impressaoParcial"
                       @change="iniciarTexto()"
                       label="Impressão Parcial do ato?" type="radio" class="col-auto" />

              <div class="w-100"></div>
              <div class="form-group input-editor col-12" v-if="form.impressaoParcial && atosParaImpressao.length">
                <label>
                  Próximo ato
                </label>

                <v-input type="editor" @change="validarTexto($event)"
                         v-model="minutaEdicao.texto" ref="editor" @onkeyup="setKeyPressed"
                         :tiny-options="{ toolbar: false, min_height: 100 }"
                />

              </div>

              <v-input label="Primeira Folha" v-model="form.primeiraFolha"
                       type="currency" :input-props="{precision : 0}" class="col" />

              <v-input v-model="form.isFrente" :default="true"
                       label="Lado Inicial" type="radio" class="col-auto" :options="ladosBoolean" />

              <v-input label="Margem Inicial do Texto (mm)" v-model="form.marginInicial"
                       type="currency" :input-props="{precision : 0}" class="col" />

              <div class="w-100"></div>

              <v-input :defaut="false" label="Adicionar Linha Antes do Primeiro Ato?"
                       v-model="form.incluirLinhaAnterior" type="radio" class="col" />

              <v-input :defaut="true" label="Incluir última linha?"
                       v-model="form.incluirLinhaFinal" type="radio" class="col" />

              <v-input v-if="version === 3" :defaut="true" label="Incluir linha divisória dos atos?"
                       v-model="form.incluirLinhaDivisoriaAtos" type="radio" class="col" />

              <div class="w-100"></div>

            </template>

            <template v-else>

              <v-input label="Imprimir até o ato:" v-model="form.ultimoAto"  v-if="form.impressaoCompleta"
                       placeholder="Deixe em branco para imprimir todos os atos"
                       type="currency" :input-props="{precision : 0}" class="col" />

              <div class="w-100"></div>

              <v-input :defaut="true" label="Incluir última linha?"
                       v-model="form.incluirLinhaFinal" type="radio" class="col" />

              <v-input v-if="version === 3" :defaut="true" label="Incluir linha divisória dos atos?"
                       v-model="form.incluirLinhaDivisoriaAtos" type="radio" class="col" />

              <v-input :defaut="false" :label="textoExternoLabel"
                       v-model="form.incluirTextoLegado" type="radio" class="col" />

            </template>

            <div class="w-100"></div>

            <v-input label="Incluir linhas de Encerramento?" v-model="form.incluirLinhaEncerramento"
                     type="radio" class="col" />

            <template v-if="form.incluirLinhaEncerramento">
              <v-input type="number" label="Quantidade de Linhas" class="col" v-model="form.quantidadeLinhas" />
            </template>

            <v-input label="Incluir texto de encerramento" v-model="form.incluirTextoEncerramento" :default="false"
                     type="radio" class="col" />

            <div class="form-group input-editor col-12" v-if="form.incluirTextoEncerramento">
              <label>
                Texto de Encerramento
              </label>

              <v-input type="editor" v-model="form.textoEncerramento" ref="editorEncerramento" :tiny-options="{ min_height: 100 }"/>
            </div>

            <div class="w-100"></div>

            <v-input label="Seguir a sequência da última folha" v-model="form.seguirSequenciaUltimaFolha" type="radio" class="col-5" />
          </template>
        </div>

      </card-content>
    </card>

    <template v-if="isLegacyIndicador && !loading">
      <card titulo="Impressões geradas" v-if="impressoesMescladas.length">
        <card-table>
          <thead>
            <tr>
              <th>Nome</th>
              <th width="150px">Cadastro</th>
              <th width="200px">Status</th>
              <th width="110px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in impressoesMescladas" :key="item._key">
              <td class="small">{{ item._nome }}</td>
              <td class="small">{{ item.cadastro | datahora }}</td>
              <td class="small">
                <span v-if="item._tipo === 'fila' && item.mensagem" class="text-danger">
                  <i class="fal fa-exclamation-triangle mr-1"></i>
                  Falha. Código de suporte: <strong>{{ item.mensagem }}</strong>
                </span>
                <span v-else-if="item._tipo === 'fila' && item.progresso != null" class="text-muted">
                  <i class="fal fa-clock mr-1"></i>Gerando… {{ item.progresso }}%
                </span>
                <span v-else-if="item._tipo === 'fila'" class="text-muted">
                  <i class="fal fa-clock mr-1"></i>Aguardando
                </span>
                <span v-else class="text-success">
                  <i class="fal fa-check-circle mr-1"></i>Concluído
                </span>
              </td>
              <td class="text-right">
                <template v-if="item._tipo === 'anexo'">
                  <v-button :run="viewAnexo" :params="[item]" :button="false" class="icon mr-2">
                    <i class="fal fa-external-link-alt" title="Visualizar"></i>
                  </v-button>
                  <anexo-wrapper-download :anexo="item" class="icon" title="Download" target="_blank">
                    <template #conteudo>
                      <i class="fal fa-download"></i>
                    </template>
                  </anexo-wrapper-download>
                  <v-button :run="excluirAnexo" :params="[item]" :button="false" class="icon ml-2" title="Excluir" :popover="true" position="dropleft">
                    <i class="fa fa-times"></i>
                  </v-button>
                </template>
              </td>
            </tr>
          </tbody>
        </card-table>
      </card>
    </template>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-2">Cancelar</button>
      <button v-if="!simulacao & tipo != 'LIVRO_ESTRANGEIRO'" type="button" @click.prevent="marcarAtosImpressos()" class="btn btn-outline-primary mr-auto">Marcar atos como impressos</button>

      <v-button v-if="!simulacao" :run="run"
                :params="['arquivar']" class="btn-outline-warning ml-2" :disabled="minutaEdicao.editando">Arquivar PDF Assinado</v-button>

      <v-button v-if="!simulacao && isLegacyIndicador" :run="run" :params="['arquivar-fila']"
                class="btn-outline-primary ml-2" :disabled="minutaEdicao.editando">Arquivar</v-button>

      <v-button v-if="!simulacao" :run="run" :params="['baixar']" class="btn-outline-primary ml-2" :disabled="minutaEdicao.editando">Baixar PDF</v-button>
      <v-button :run="run" :class="simulacao ? 'ml-auto' : ''" class="btn-outline-primary ml-2" :disabled="minutaEdicao.editando">Visualizar</v-button>
    </template>

  </modal>
</template>

<script>
import LayoutImpressaoBusiness from "@/business/crud/LayoutImpressaoBusiness.js";
import FrontBusiness from "@/business/FrontBusiness";
import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness.js";
import RegistroAuxiliarBusiness from "@/business/indicadores/RegistroAuxiliarBusiness.js";
import RegistroNotasBusiness from "@/business/indicadores/RegistroNotasBusiness.js";
import AtoBusiness from "@/business/protocolo/AtoBusiness.js";
import RelatorioBusiness from "@/business/RelatorioBusiness.js";
import AnexoBusiness from "@/business/AnexoBusiness.js";
import AsgardStorageBusiness from "@/business/cloudStorage/AsgardStorageBusiness.js";
import Utils from "@/commons/Utils";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import CardTable from "@/components/Layout/components/CardTable.vue";
import Modal from "@/components/Modal";
import moment from "moment";
import AlertBanner from "@/components/alert/AlertBanner";
import LacunaBusiness from "@/business/LacunaBusiness";
import Ajuda from "@/components/Checklist/Ajuda.vue";
import AnexoWrapperDownload from "@/components/Anexos/AnexoWrapperDownload.vue";

export default {
    name: "ImprimirFichaV2",
    components: {CardContent, Card, CardTable, AlertBanner, Modal, AnexoWrapperDownload},

    props: ['tipo', 'id', 'codigo', 'simulacao', 'atosSimulacao','idAto'],

    async mounted() {
      try {

      let promise, promises, alerta;
      if (this.tipo == 'REGISTRO_AUXILIAR') {
        if (!this.simulacao) {
          promise = RegistroAuxiliarBusiness.buscarAtosRegistrados(this.id);
        }
        alerta = RegistroAuxiliarBusiness.verificarAtosImpressao(this.id);
        promises = [LayoutImpressaoBusiness.listByTipo('REGISTRO_AUXILIAR_V2'), LayoutImpressaoBusiness.listByTipo('REGISTRO_AUXILIAR_V3')];
      } else if (this.tipo == 'TRANSCRICAO') {
        promise = IndicadorRealBusiness.buscarAtosRegistrados(this.id);
        promises = [LayoutImpressaoBusiness.listByTipo('TRANSCRICAO')];
      } else if (this.tipo === 'REGISTRO_TD') {
        promises = [
          LayoutImpressaoBusiness.listByTipo('REGISTRO_TD'),
          LayoutImpressaoBusiness.listByTipo('REGISTRO_TD_V3')
        ];
      } else if (this.tipo === 'REGISTRO_PJ') {
        promises = [
          LayoutImpressaoBusiness.listByTipo('REGISTRO_PJ'),
          LayoutImpressaoBusiness.listByTipo('REGISTRO_PJ_V3')
        ];
      } else if (this.tipo === 'TRANSCRICAO') {
        promises = [LayoutImpressaoBusiness.listByTipo('TRANSCRICAO')];
      } else if(this.tipo == 'LIVRO_ESTRANGEIRO'){
        if (!this.simulacao) {
          promise = IndicadorRealBusiness.buscarAtosRegistrados(this.id);
        }
        alerta = IndicadorRealBusiness.verificarAtosImpressao(this.id);
        promises = [LayoutImpressaoBusiness.listByTipo('LIVRO_ESTRANGEIRO')];
      } else if (this.tipo == 'REGISTRO_NOTAS') {
        if (!this.simulacao) {
          promise = RegistroNotasBusiness.buscarAtosRegistrados(this.id);
        }
        alerta = RegistroNotasBusiness.verificarAtosImpressao(this.id);
        promises = [LayoutImpressaoBusiness.listByTipo('ATO_NOTARIAL')];
      } else {
        if (!this.simulacao) {
          promise = IndicadorRealBusiness.buscarAtosRegistrados(this.id);
        }
        alerta = IndicadorRealBusiness.verificarAtosImpressao(this.id);
        promises = [LayoutImpressaoBusiness.listByTipo('MATRICULA_V2'), LayoutImpressaoBusiness.listByTipo('MATRICULA_V3')];
      }

      let r = await Promise.all(promises);
      this.layouts = [...r[0], ...(r?.[1] || [])];
      this.$set(this.form, 'layout', this.layouts?.[0]?.id);
      this.aplicarDpiLayout();

      this.alerta = !(await alerta);
      this.atos = (await promise) || [];

      this.$set(this.form, 'completo', false);
      await this.carregarMemoria();

      if (['REGISTRO_TD', 'REGISTRO_PJ'].includes(this.tipo)) {
        await this.carregarFilaStatus();
        await this.carregarAnexosImpressao();
      }

      } catch (err) {
        console.error(err);
      } finally {
        this.$set(this, 'loading', false);
      }

    },

    modal: {
      // width: 400,
      escapable: true
    },

    data() {
      return {
        loading: true,

        atos: [],
        alerta: false,
        layouts: [],
        dpiDigitalizacao: this.$root.enums?.EnumDpiDigitalizacao,
        dpiDigitalizacaoLayout: 'MEDIO',

        lados: [
          {id: 'frente', nome: 'Frente'},
          {id: 'verso', nome: 'Verso'},
        ],

        ladosBoolean: [
          {id: true, nome: 'Frente'},
          {id: false, nome: 'Verso'},
        ],

        template: '',
        form: {

          layout: null,
          dpiDigitalizacao: 'MEDIO',

          ultimoAto: null,
          impressaoCompleta: true,
          considerarAtosDigitais: true,
          impressaoParcial: false,
          incluirLinhaAnterior : false,
          incluirLinhaEncerramento: false,
          seguirSequenciaUltimaFolha: true,
          incluirLinhaFinal: true,
          incluirLinhaDivisoriaAtos: true,
          incluirTextoLegado: false,
          quantidadeLinhas: 1,
          primeiraFolha: 1,
          isFrente: true,
          marginInicial: 0,

          padrao: {}

        },

        minutaEdicao: {
          atualizado: null,
          editando: false,
          validando: false,
          init: null,
          texto: ''
        },

        keyPressed: null,

        validarTexto: Utils.debounce(this.validarTextoFnc, 300),

        textosAjuda: {
          dpiDigitalizacao: LayoutImpressaoBusiness.textoAjudaQualidadeImagem()
        },

        filaStatus: [],
        impressoesAnexos: [],
        pollingInterval: null

      }
    },

    computed: {

      atosParaImpressao(){
        let atosParaImpressao = (Utils.clone(this.atos)).filter(a => this.form.impressaoCompleta  || (!a.impressao && this.form.impressaoParcial !== null)) || [];
        return atosParaImpressao;
      },

      dataImpressao(){
        return moment(this.atosParaImpressao?.[0]?.registro);
      },

      matricula() {
        return this.codigo || '123.123';
      },

      version() {
        console.debug(this.layouts.find(e => e.id == this.form.layout))
if (['REGISTRO_PJ', 'REGISTRO_TD', 'TRANSCRICAO', 'REGISTRO_NOTAS'].includes(this.tipo)) {
          return 3
        }
        return this.layoutSelecionado?.tipo?.includes('_V3') ? 3 : 2;
      },

      layoutSelecionado() {
        return this.layouts.find(e => e.id == this.form.layout);
      },

      isLayoutV3() {
        return this.layoutSelecionado?.tipo?.includes('_V3');
      },

      isLegacyIndicador() {
        return ['REGISTRO_TD', 'REGISTRO_PJ'].includes(this.tipo) && !this.isLayoutV3;
      },

      textoExternoLabel() {
        const tipo = this.layoutSelecionado?.tipo;
        if (tipo === 'REGISTRO_TD_V3' || tipo === 'REGISTRO_PJ_V3') {
          return 'Incluir texto externo? (Registros importados com texto externo)';
        }
        return 'Incluir texto externo? (Matrículas importadas com texto externo)';
      },

      impressoesMescladas() {
        const filaFiltrada = this.filaStatus
          .filter(item => !item.concluido || item.mensagem)
          .map(item => ({
            ...item,
            _key: 'fila-' + item.id,
            _tipo: 'fila',
            _nome: this.nomeLayout(item),
          }));

        const anexosMapeados = this.impressoesAnexos.map(anexo => ({
          ...anexo,
          _key: 'anexo-' + anexo.id,
          _tipo: 'anexo',
          _nome: anexo.nomeAnexo,
        }));

        return [...filaFiltrada, ...anexosMapeados]
          .sort((a, b) => new Date(b.cadastro) - new Date(a.cadastro));
      },

    },

    watch: {
      'form.layout'() {
        this.aplicarDpiLayout();
      },
    },

    beforeDestroy() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },

    methods: {

      nomeLayout(item) {
        const layout = this.layouts.find(l => l.id == item.layoutId);
        return layout?.nome || '—';
      },

      aplicarDpiLayout() {
        const dpi = this.layoutSelecionado?.dpiDigitalizacao || 'MEDIO';
        this.$set(this, 'dpiDigitalizacaoLayout', dpi);
        this.$set(this.form, 'dpiDigitalizacao', dpi);
      },

      exibirAjuda(ajuda) {
        FrontBusiness.openModal(Ajuda, {ajuda});
      },

      esc(e) {
        if (e.keyCode === 27) this.close()
      },

      iniciarTexto(e){
        this.$set(this.minutaEdicao, 'texto', this.atosParaImpressao?.[0]?.texto);
      },

      validarTextoFnc(e){

        try{

          const limparString = (str) => {
            return Utils.clone((Utils.removeHTML(str)).replace(/(\r\n|\n|\r)/gm, "").replace(/\s+/g,'').replaceAll(" ", "").trim());
          }

          const original = limparString(this.atosParaImpressao?.[0]?.texto);
          const modificado = limparString(this.minutaEdicao.texto);

          // console.debug('validarTexto', {original, modificado, result: original.endsWith(modificado), keyPressed: this.keyPressed});

          if(!original.endsWith(modificado) || !modificado || (this.keyPressed && this.keyPressed != 46 && this.keyPressed != 8)){

            let msg = !this.minutaEdicao.texto?.length ? 'Não é permitido apagar todo o conteúdo do ato' : 'Permitido editar apenas o início do ato';

            this.iniciarTexto();

            setTimeout(() => {
              let modal = document.getElementById('modal-imprimir');
              if(modal) {
                FrontBusiness.showError('', msg);
              }
            }, 100);
            this.$forceUpdate();
          }

        }catch (e){
          console.error(e);
        }

      },

      async clickEditor(e, focus = false) {
        console.debug(e, focus);
        if (focus && !this.minutaEdicao.editando) {
          this.minutaEdicao.editando = true;
          this.minutaEdicao.init = Utils.clone(this.$refs.editor.$el.innerText);
        } else if (!focus) {
          this.minutaEdicao.validando = true;
          let newValue = this.$refs.editor.$el.innerText;
          if (newValue.charCodeAt(0) === 160) newValue = newValue.split(newValue.charAt(0))[1];
          if ((this.minutaEdicao.init || '').endsWith(newValue)) {
            await this.$set(this.atosParaImpressao[0], 'texto', Utils.clone(this.minutaEdicao).texto);
          } else {
            let msg = !Utils.clone(this.minutaEdicao).texto.length ? 'Não é permitido apagar todo o conteúdo do ato' : 'Permitido editar apenas o início do ato'
            setTimeout(() => {
              let modal = document.getElementById('modal-imprimir');
              if(modal) FrontBusiness.showError('', msg)
            })
            await this.$set(this.minutaEdicao, 'texto', Utils.clone(this.atosParaImpressao[0]).texto);
          }
          await this.$forceUpdate();
          this.minutaEdicao.init = null;
          this.minutaEdicao.validando = false;
          this.minutaEdicao.editando = false;
        }
      },

      CaptureKeys( editor ) {
        editor.editing.view.document.on( 'keydown', ( evt, data ) => {
          if (data.domEvent.keyCode !== 46 && !([37, 38, 39, 40].includes(data.domEvent.keyCode))) data.domEvent.returnValue = false;
        })
      },

      close(response) {
        FrontBusiness.closeModal(response);
      },

      async run(modo = 'visualizar') {

        if(!this.form.layout){
          return;
        }

        this.$set(this.minutaEdicao, 'atualizado', this.$moment());
        if(!this.form.impressaoCompleta && this.form.impressaoParcial) {
          this.validarTextoFnc();
        }

        try{
          await LayoutImpressaoBusiness.confirmarDpiAlto(this.form.dpiDigitalizacao, this.dpiDigitalizacaoLayout);

          let dto = {
            impressaoCompleta : this.form.impressaoCompleta,
            considerarAtosDigitais : this.form.considerarAtosDigitais,
            marginInicial : this.form.marginInicial,
            dpiDigitalizacao: this.form.dpiDigitalizacao,

            incluirLinhaAnterior : this.form.incluirLinhaAnterior,
            incluirLinhaFinal: this.form.incluirLinhaFinal,
            incluirLinhaDivisoriaAtos: this.form.incluirLinhaDivisoriaAtos,

            incluirLinhaEncerramento : this.form.incluirLinhaEncerramento,
            quantidadeLinhas : this.form.quantidadeLinhas,

            incluirTextoLegado : this.form.incluirTextoLegado,
            primeiroAto : this?.minutaEdicao?.texto,

            incluirTextoEncerramento : this.form.incluirTextoEncerramento,
            textoEncerramento : this.form.textoEncerramento,
            ultimoAto: !this.form.impressaoCompleta ? 999999 : this.form.ultimoAto,

            livro : this.form.livro,
          }

          if(!this.form.impressaoCompleta) {
            dto.impressaoParcial = this.form.impressaoParcial;
            dto.primeiraFolha = this.form.primeiraFolha;
            dto.isFrente = this.form.isFrente;
          }

          const atosSimulacao = this.atosSimulacao || []
          if (atosSimulacao.length) {
            const registro = this.$moment().format('YYYY-MM-DD')
            dto.atos = atosSimulacao
              .map(a => {
                const livros = a.livros || []
                const primeiro = livros[0]
                const ultimo = livros[livros.length - 1]
                return {
                  id: a.id,
                  registro,
                  texto: a.texto ?? a.minuta ?? '',
                  livroInicial: primeiro?.numeroControleLivro,
                  folhaInicial: primeiro?.numeroControleFolha,
                  ladoInicial: primeiro?.ladoPaginaControleInicial,
                  livroFinal: ultimo?.numeroControleLivro,
                  folhaFinal: ultimo?.numeroControleFolhaFinal,
                  ladoFinal: ultimo?.ladoPaginaControleFinal,
                }
              })
          }

          console.debug('config', dto);

          // Para layouts legados de REGISTRO_TD/PJ, geração síncrona causaria timeout (504) em
          // registros com muitos atos digitalizados. Enfileiramos o PDF em background e exibimos
          // o arquivo gerado na lista "Impressões geradas" assim que concluído.
          if (this.isLegacyIndicador && modo === 'arquivar-fila') {
            await LayoutImpressaoBusiness.enfileirarImpressaoIndicador(this.form.layout, this.id, dto);
            FrontBusiness.showSuccess('', 'PDF adicionado à fila de geração. O arquivo ficará disponível na lista "Impressões geradas" assim que concluído.');
            await this.carregarFilaStatus();
            return;
          }

          let pdf = LayoutImpressaoBusiness.imprimirFichaUrl(this.tipo, this.form.layout, this.id, this.version);
          if (this.tipo === 'LIVRO_ESTRANGEIRO') {
            pdf = `api/livro-estrangeiro/${this.form.layout}/imprimir/${this.idAto}`;
          }

          switch (modo){
            case 'arquivar':{

              dto.indicador = this.id;
              if (this.tipo === 'LIVRO_ESTRANGEIRO') {
                dto.idAto = this.idAto;
              }
              await LacunaBusiness.sign('arquivar-impressao', this.form.layout, '', 'impressao-eletronica.pdf', false, dto, false).then(() => {
                FrontBusiness.showSuccess('', 'Impressão arquivada com sucesso');
              }).catch(e => {
                FrontBusiness.showError('Erro ao tentar assinar o livro', e?.message || e);
                return false;
              });

              // await this.$api.post(`${pdf}/true`, dto).then(e => {
              //   FrontBusiness.showSuccess('', 'Impressão arquivada com sucesso');
              // }).catch(e => {
              //   FrontBusiness.showError('Erro ao arquivar impressão', e.message);
              // });

              // await RelatorioBusiness.visualizarPdf(pdf, 'impressao', 'POST', dto);
              break;
            }
            case 'visualizar':{
              await RelatorioBusiness.visualizarPdf(pdf, 'impressao', 'POST', dto);
              break;
            }
            default:{
              await RelatorioBusiness.downloadPdf(pdf, 'impressao', 'POST', dto);
              break;
            }
          }

        }catch (e){
          console.error(e);
        }
      },

      async carregarFilaStatus() {
        try {
          this.filaStatus = await LayoutImpressaoBusiness.statusFilaImpressaoIndicador(this.id);
        } catch (e) {
          this.filaStatus = [];
        }
        this.atualizarPolling();
      },

      async carregarAnexosImpressao() {
        try {
          this.impressoesAnexos = await AnexoBusiness.listar('IMPRESSAO_INDICADOR', this.id);
        } catch (e) {
          this.impressoesAnexos = [];
        }
      },

      async excluirAnexo(item) {
        await AnexoBusiness.deleteById(item.id).catch(e => FrontBusiness.showError('', e.message));
        await this.carregarAnexosImpressao();
      },

      async viewAnexo(arquivo) {
        let timestamp;
        if (this.$root.isEstadoRS) {
          timestamp = this.$moment().valueOf();
        }
        const link = AsgardStorageBusiness.getViewUrl(arquivo, false, timestamp);
        await FrontBusiness.abrirJanela(null, 'Visualizar Anexo', link);
      },

      atualizarPolling() {
        const temPendente = this.filaStatus.some(item => !item.concluido && !item.mensagem);
        if (temPendente && !this.pollingInterval) {
          this.pollingInterval = setInterval(async () => {
            try {
              this.filaStatus = await LayoutImpressaoBusiness.statusFilaImpressaoIndicador(this.id);
            } catch (e) {
              // mantém o status anterior em caso de falha de rede
            }
            if (!this.filaStatus.some(item => !item.concluido && !item.mensagem)) {
              clearInterval(this.pollingInterval);
              this.pollingInterval = null;
              await this.carregarAnexosImpressao();
            }
          }, 2000);
        } else if (!temPendente && this.pollingInterval) {
          clearInterval(this.pollingInterval);
          this.pollingInterval = null;
        }
      },

      async marcarAtosImpressos() {
        await AtoBusiness.marcarAtosImpressos(this.tipo, this.id, true);
        FrontBusiness.showSuccess('', 'Atos marcados como impressos com sucesso!');
      },

      setKeyPressed(event){
        this.$set(this, 'keyPressed',  event.which || event.keyCode);
      },

      setNonNull(key, value){
        if(value != undefined){
          this.$set(this.form, key, value);
        }
      },

      async carregarMemoria(){
        // if(false){
          this.$set(this, 'loading', true);
          let cfg = await RelatorioBusiness.ultimaImpressaoFicha(this.tipo, this.id);
          if(cfg?.layout){
            this.setNonNull('impressaoCompleta', cfg?.impressaoCompleta);
            this.setNonNull('primeiraFolha', cfg?.primeiraFolha);
            this.setNonNull('isFrente', cfg?.isFrente);
            this.setNonNull('marginInicial', cfg?.marginInicial);
            this.setNonNull('incluirLinhaAnterior', cfg?.incluirLinhaAnterior);
            this.setNonNull('incluirLinhaFinal', cfg?.incluirLinhaFinal);
            this.setNonNull('incluirLinhaDivisoriaAtos', cfg?.incluirLinhaDivisoriaAtos);
            this.setNonNull('incluirLinhaEncerramento', cfg?.incluirLinhaEncerramento);
            this.setNonNull('quantidadeLinhas', cfg?.quantidadeLinhas);
            this.setNonNull('impressaoParcial', cfg?.impressaoParcial);
            this.setNonNull('primeiroAto', cfg?.primeiroAto);
            this.setNonNull('incluirTextoEncerramento', cfg?.incluirTextoEncerramento);
            this.setNonNull('textoEncerramento', cfg?.textoEncerramento);
            this.setNonNull('livro', cfg?.livro);
            this.setNonNull('layout', cfg?.layout);
          }
          this.$set(this, 'loading', false);
        // }
      },

    }
  }
</script>
